/*
 * Ambient crossfade rotation for sections/client-showcase-grid.liquid.
 * Only touches tiles marked [data-csg-rotate] (a 2nd photo was added to
 * that client block). Same round-robin single-clock approach as the hero
 * text-image-grid: one shared clock per .csg-grid advances exactly one
 * rotating tile per tick, so at most one tile is ever crossfading at a
 * time, evenly spaced. The clock only runs while the grid is on screen,
 * and nothing runs if the visitor has asked for reduced motion.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var grids = document.querySelectorAll('.csg-grid:not([data-csg-inited])');
  if (!grids.length) return;

  grids.forEach(function (grid) {
    grid.setAttribute('data-csg-inited', 'true');

    var tileEls = grid.querySelectorAll('[data-csg-rotate]');
    var rotators = [];
    tileEls.forEach(function (tile) {
      var images = tile.querySelectorAll('.csg-tile__img');
      if (images.length > 1) {
        rotators.push({ images: images, activeIndex: 0, interval: tile.getAttribute('data-csg-interval') });
      }
    });

    if (!rotators.length) return;

    var gap = parseInt(rotators[0].interval, 10) || 4000;
    var pointer = 0;
    var timer = null;

    function advanceOne() {
      var r = rotators[pointer];
      r.images[r.activeIndex].classList.remove('is-active');
      r.activeIndex = (r.activeIndex + 1) % r.images.length;
      r.images[r.activeIndex].classList.add('is-active');
      pointer = (pointer + 1) % rotators.length;
    }

    function start() {
      if (timer) return;
      timer = window.setInterval(advanceOne, gap);
    }

    function stop() {
      window.clearInterval(timer);
      timer = null;
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              start();
            } else {
              stop();
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(grid);
    } else {
      start();
    }
  });
})();

/*
 * Right-click guard for the Client Showcase Grid. Scoped to .csg-grid
 * only (not site-wide) - blocks the browser's "Save image as..." /
 * "Copy image" context menu on these tiles. Paired with the
 * draggable="false" attributes and CSS user-drag/user-select rules on
 * .csg-tile__img and .csg-tile__logo-img. This is a casual deterrent,
 * not real protection - a screenshot or browser dev tools still work.
 */
(function () {
  document.querySelectorAll('.csg-grid:not([data-csg-context-guarded])').forEach(function (grid) {
    grid.setAttribute('data-csg-context-guarded', 'true');
    grid.addEventListener('contextmenu', function (event) {
      event.preventDefault();
    });
  });
})();
